// Map of canonical `autoDocExtField` names to the feature flag that gates
// their suggestion UI. Fields absent from the map are never gated (e.g.
// `sponsorship_source` ships unconditionally).
//
// This is for DE2 only. DE1 flags are managed on the server side, via the
// AutoDocumentExtractions::FieldAliases::FIELDS_TO_FEATURE_FLAGS constant.
const FIELD_FLAGS: Record<string, string> = {
  // Below is an example - the country field is already released publicly
  // country: 'autodoc_de2_country_field',
};

export const isFeatureEnabledForField = (
  autoDocExtField: string,
  hasFeature: (flag: string) => boolean,
  fieldFlags: Record<string, string> = FIELD_FLAGS
): boolean => {
  const flag = fieldFlags[autoDocExtField];

  return flag === undefined || hasFeature(flag);
};
